import { Table } from '@tanstack/react-table';

import { HeaderCell } from './HeaderCell';

export interface TableHeaderProps<T> {
  table: Table<T>;
  dataTestId?: string;
}

export const TableHeader = <T,>({ table }: TableHeaderProps<T>) => {
  return (
    <thead>
      {table.getHeaderGroups().map(headerGroup => (
        <tr key={headerGroup.id}>
          {headerGroup.headers.map(columnHeader => (
            <HeaderCell key={columnHeader.id} columnHeader={columnHeader} />
          ))}
        </tr>
      ))}
    </thead>
  );
};
